<section class="list-view-instance" role="row" tabindex="0">
    <div class="s-list-item fx-desktop-only" [ngClass]="{'grow-list-item' : info || options, 'disabled-list' : (survey.timeExtensionIndicator === 'NULL')}">
        <section class="list-view-row">
            <div class="uscb-layout-row uscb-layout-align-flex-start uscb-layout-align-vert-center uscb-padding-TB-15 uscb-padding-LR-0">
                <div class="uscb-layout-row uscb-layout-align-flex-start uscb-layout-align-vert-center uscb-flex-row-20" role="cell" headers="survey-list-header-name">
                    <div class="uscb-flex uscb-bold">
                        {{survey.displayName}}
                    </div>
                    <div class="fx-flex-none">
                        @if (survey.timeExtensionIndicator !== 'NULL' && (survey.surveyInformation || survey.infoUrl)) {
                        <span>
                            <i class="fa fa-info-circle fa-lg uscb-cursor-pointer-hover uscb-margin-8 ecorr-opacity-_6" (click)="infoClick()" (keyup.enter)="infoClick()" tabindex="0"
                            [attr.aria-label]="'Info for ' + survey.displayName" [attr.aria-expanded]="info" role="button"></i>
                        </span>
                        }
                        @if (survey.timeExtensionIndicator === 'NULL' && (survey.surveyInformation || survey.infoUrl)) {
                        <span>
                            <i class="fa fa-info-circle fa-lg uscb-margin-8 ecorr-opacity-_3"></i>
                        </span>
                        }
                    </div>
                </div>
                <div class="uscb-flex-row-15" role="cell" headers="survey-list-header-duedate">
                    @if (survey.surveyCategory !== 'MEPS' && survey.surveyTypeName !== 'ECON - TCIM' && survey.surveyTypeName !== 'ACES') {
                    <div>{{survey.originalDueDate | date:'longDate'}}</div>
                    }
                    @if (survey.extended && survey.surveyCategory !== 'MEPS' && survey.surveyTypeName !== 'ECON - TCIM' && survey.surveyTypeName !== 'ACES') {
                    <div class="uscb-color-black uscb-padding-L-0">
                        <b>Extended:</b>
                        {{survey.currentDueDate | date:'longDate'}}</div>
                    }
                    @if (active) {
                    <div class="uscb-layout-column uscb-flex">
                        <button aria-label="export to calendar" type="button" class="uscb-transparent-button uscb-margin-0 uscb-padding-0 uscb-text-align-left"
                            (click)="exportSurvey()" (keyup.enter)="exportSurvey()" tabindex="0">
                            <i class="fa fa-calendar"></i> Export to Calendar
                        </button>
                    </div>
                    }
                </div>
                <div class="uscb-flex-row-15" role="cell" headers="survey-list-header-orgname">
                    {{survey.organizationName}}
                </div>
                <div class="uscb-flex-row-10" role="cell" headers="survey-list-header-orgid">
                    {{survey.brOrganizationId}}
                </div>
                <div class="uscb-flex-row-15" role="cell" headers="survey-list-header-accmgr">
                    {{survey.accountManager}}
                    <span> {{survey.accountManagerPhoneNumber}}&nbsp;</span>
                </div>
                <div class="uscb-flex uscb-layout-row" role="cell" headers="survey-list-header-options">
                    @if (survey.timeExtensionIndicator !== 'NULL' && active) {
                    <div class="uscb-layout-column uscb-flex">
                        <button aria-label="options" type="button"
                            class="uscb-transparent-button uscb-margin-0 uscb-padding-TB-0 uscb-paddding-LR-5" (click)="optionsClick()"
                            [ngClass]="options ? 'button-pressed' : 'button-released'" tabindex="0" [attr.aria-expanded]="options">
                            @if (!options) {
                            <i class="fa fa-plus-circle ecorr-opacity-_6"></i>
                            }
                            @if (options) {
                            <i class="fa fa-minus-circle ecorr-opacity-_6"></i>
                            }
                            &nbsp;OPTIONS
                        </button>
                    </div>
                    }
                    @if (survey.timeExtensionIndicator !== 'NULL' && !showOnlyMessage) {
                    <div class="uscb-layout-column uscb-flex">
                        @if (!active) {
                        <button disabled class="ecorr-list-button-closed md-button md-primary md-raised uscb-button-primary ecorr-button-disabled uscb-flex">
                            <h4 class="md-subhead">SURVEY CLOSED</h4>
                        </button>
                        }
                        
                        <!-- This is for accessCenturionV1 survey with no case Id and submitted using form -->
                        @if (active && !survey.caseId) {
                        <form id="startForm" ngNoForm [action]="survey.centurionUrl" method="POST" target="_blank" class="uscb-form">
                            <input id="authCode" name="authCode" value="{{survey.smartId}}" type="hidden">
                            <!-- Centurion SSO -->
                            <input id="origin" name="origin" value="portal" type="hidden">

                            <button type="submit" #submitButton class="uscb-primary-button uscb-margin-0 uscb-padding-TB-0 uscb-adding-LR-5 fx-flex-none"
                                [disabled]="survey.reportingEnabled ==='N' ||survey.timeExtensionIndicator === 'NULL'"
                                (click)="accessCenturion(survey, currentUser()?.userAccountId)" (keyup.enter)="accessCenturion(survey, currentUser()?.userAccountId)"
                                [matTooltip]="survey.disabledMessage" matTooltipClass="tooltip" tabindex="0">
                                REPORT NOW
                            </button>
                        </form>
                        }

                        <!-- This is for accessCenturionV2 survey  like AIES service with Case ID -->
                        @if (active && (survey.caseId && survey.caseId > 0)) {
                        <div class="fx-row">
                            <button class="uscb-primary-button uscb-margin-0 uscb-padding-TB-0 uscb-adding-LR-5 fx-flex-none"
                                [disabled]="survey.reportingEnabled ==='N' ||survey.timeExtensionIndicator === 'NULL'"
                                (click)="accessCenturion(survey, currentUser()?.userAccountId)" (keyup.enter)="accessCenturion(survey, currentUser()?.userAccountId)"
                                [matTooltip]="survey.disabledMessage" matTooltipClass="tooltip" tabindex="0">
                                REPORT NOW
                            </button>
                        </div>
                        }

                    </div>
                    }
                    @if (showOnlyMessage) {
                    <div class="uscb-flex">
                        <button class="uscb-flex uscb-primary-button slim-padding" (click)="accessMessages()" (keyup.enter)="accessMessages()" tabindex="0">
                            ACCESS MESSAGES
                        </button>
                    </div>
                    }
                    @if (survey.timeExtensionIndicator === 'NULL') {
                    <div class="uscb-layout-column uscb-flex">
                        <span class="config-error-text"><b>There is a configuration error for this survey. Please contact the survey help
                                desk for assistance.</b>
                        </span>
                    </div>
                    }
                </div>
            </div>

            @if (options) {
            <div class="ops-row">
                @if (active) {
                <div class="info-row uscb-layout-row uscb-layout-align-space-between ecorr-survey-card-extension ecorr-padding-TOP-xsm ecorr-padding-BTM-xsm center-content">
                    @if (!showOnlyMessage) {
                    <ng-container>
                        <button title="Request Extension" (click)="requestExtension()" (keyup.enter)="requestExtension()" class="uscb-transparent-button"
                        [disabled]="survey.timeExtensionIndicator !== 'Y' || !currentSettings().pegaIntegration" tabindex="0">
                            <i class="fa fa-clock-o"></i>Request Extension
                        </button>
                        <button title="Share Survey Access" (click)="shareAccess()" (keyup.enter)="shareAccess()" class="uscb-transparent-button" tabindex="0">
                            <i class="fa fa-users"></i>Share Survey Access
                        </button>
                        <button title="Filing Status" (click)="checkStatus()" (keyup.enter)="checkStatus()" class="uscb-transparent-button" tabindex="0">
                            <i class="fa fa-check-square-o"></i>Filing Status
                        </button>

                        @if (!showFaqChildren) {
                        <button title="Survey FAQs" (click)="viewFAQs(-1)" (keyup.enter)="viewFAQs(-1)" class="uscb-transparent-button" tabindex="0">
                            <i class="fa fa-question-circle"></i>Survey FAQs
                        </button>
                        }
                        @if (showFaqChildren) {
                        <button title="Rpt. of Org. FAQs" (click)="viewFAQs(0)" (keyup.enter)="viewFAQs(0)" class="uscb-transparent-button" tabindex="0">
                            <i class="fa fa-question-circle"></i>Rpt. of Org. FAQs
                        </button>
                        <button title="ASM FAQs" (click)="viewFAQs(1)" (keyup.enter)="viewFAQs(1)" class="uscb-transparent-button" tabindex="0">
                            <i class="fa fa-question-circle"></i>ASM FAQs
                        </button>
                        }
                    </ng-container>
                    }

                    <button title="Send Message" [disabled]="!currentSettings().pegaIntegration" (click)="sendMessage()" (keyup.enter)="sendMessage()"
                        class="uscb-transparent-button" tabindex="0">
                        <i class="fa fa-envelope"></i>Send Message
                    </button>

                    @if (survey.phoneNbr) {
                    <button class="uscb-transparent-button ecorr-cursor-default" tabindex="0">
                        <i class="fa fa-phone"></i> Call Survey Support: {{survey.phoneNbr}}
                    </button>
                    }
                </div>
                }
            </div>
            }

            @if (info) {
            <div class="info-row uscb-layout-column">
                <p [innerHtml]="survey.surveyInformation | decodeXml | byPassSecurity"></p>
                @if (survey.infoUrl) {
                <div>
                    @if (!survey.infoUrl.includes(';')) {
                    <button (click)="moreInfoClick(-1)" (keyup.enter)="moreInfoClick(-1)" class="uscb-transparent-button" tabindex="0">MORE
                        INFORMATION</button>
                    }
                    @if (survey.infoUrl.includes(';')) {
                    <button (click)="moreInfoClick(0)" (keyup.enter)="moreInfoClick(0)" class="uscb-transparent-button" tabindex="0">Rpt. of
                        Org. INFORMATION</button>
                    <button (click)="moreInfoClick(1)" (keyup.enter)="moreInfoClick(1)" class="uscb-transparent-button" tabindex="0">ASM
                        INFORMATION</button>
                    }
                </div>
                }
            </div>
            }
        </section>
    </div>

    <!-- Mobile -->
    <div class="resp-surveys-list uscb-layout-column uscb-layout-align-center uscb-layout-align-vert-stretch uscb-margin-B-15 fx-mobile-only"
        [ngClass]="{'resp-disabled-list' : (survey.timeExtensionIndicator === 'NULL')}">
        <section class="mobile-card">
            <div class="resp-s-header uscb-layout-row uscb-flex uscb-layout-align-space-between uscb-layout-align-vert-center">
                <span>{{survey.displayName}}</span>
                @if (survey.timeExtensionIndicator !== 'NULL' && (survey.surveyInformation || survey.infoUrl)) {
                <span>
                    <i class="fa fa-info-circle fa-2x uscb-cursor=pointer-hover ecorr-opacity-_6" (click)="infoClick()" (keyup.enter)="infoClick()" tabindex="0"></i>
                </span>
                }
                @if (survey.timeExtensionIndicator === 'NULL' && (survey.surveyInformation || survey.infoUrl)) {
                <span>
                    <i class="fa fa-info-circle fa-lg ecorr-opacity-_3"></i>
                </span>
                }
            </div>
            <div class="uscb-flex-row-100 uscb-layout-row uscb-padding-B-15">
                <div class="uscb-flex-row-60 uscb-layout-column">
                    @if (survey.surveyCategory !== 'MEPS' && survey.surveyTypeName !== 'ECON - TCIM' && survey.surveyTypeName !== 'ACES') {
                    <div class="top-padding uscb-flex"><span><b>Due:</b>&nbsp;
                            {{survey.originalDueDate | date:'longDate'}}</span></div>
                    <div class="top-padding uscb-flex"><span><b>Extended:</b>&nbsp;
                            {{survey.currentDueDate | date:'longDate'}}</span></div>
                    }
                    <div class="top-padding uscb-flex"><b>Name: </b>&nbsp; {{survey.organizationName}}</div>
                    <div class="top-padding uscb-flex"><b>ID: </b>&nbsp; {{survey.brOrganizationId}}</div>
                    @if (survey.accountManager) {
                    <div class="top-padding uscb-flex"><b>Account Manager: </b>&nbsp;
                        <i class="fa fa-info-circle fa-lg uscb-cursor-pointer-hover ecorr-opacity-_6 uscb-margin-8" [matTooltip]="accountManagerTooltipHtml | decodeXml"
                            matTooltipClass="tooltip"></i>
                        {{survey.accountManager}},&nbsp; {{survey.accountManagerPhoneNumber}}
                    </div>
                    }
                    @if (survey.disabledMessage && survey.disabledMessage.length > 0) {
                    <div class="top-padding uscb-flex">
                        {{survey.disabledMessage}}</div>
                    }
                </div>
                <div class="uscb-flex-row-40 uscb-layout-column">
                    @if (!showOnlyMessage) {
                    <div class="top-padding uscb-flex">
                        @if (active) {
                        <button [disabled]="survey.timeExtensionIndicator === 'NULL' || survey.reportingEnabled === 'N'"
                        class="uscb-primary-button" (click)="accessCenturion(survey, currentUser()?.userAccountId)" (keyup.enter)="accessCenturion(survey, currentUser()?.userAccountId)"
                        [matTooltip]="survey.disabledMessage | decodeXml" matTooltipClass="tooltip" tabindex="0">
                        REPORT NOW
                    </button>
                        }
                        @if (!active) {
                        <span><b>SURVEY CLOSED</b></span>
                        }
                    </div>
                    }
                    @if (showOnlyMessage) {
                    <div class="top-padding uscb-flex">
                        <button class="xs-flex-resp-btn md-button md-primary md-raised" (click)="accessMessages()" (keyup.enter)="accessMessages()" tabindex="0">
                            <h4 class="md-subhead"><b>ACCESS MESSAGES</b></h4>
                        </button>
                    </div>
                    }
                    @if (active) {
                    <div class="top-padding uscb-flex">
                        <button aria-label="export to calendar" type="button" class="uscb-transparent-button uscb-margin-0 uscb-padding-TB-0 uscb-padding-LR-5"
                            (click)="exportSurvey()" (keyup.enter)="exportSurvey()" tabindex="0">
                            <i class="fa fa-calendar"></i> Export to Calendar
                        </button>
                    </div>
                    }
                    @if (active) {
                    <div class="top-padding uscb-flex">
                        <button aria-label="options" type="button" class="uscb-transparent-button uscb-margin-0 uscb-padding-TB-0 uscb-padding-LR-5" (click)="optionsClick()" (keyup.enter)="optionsClick()"
                            [ngClass]="options ? 'button-pressed' : 'button-released'"
                            [disabled]="survey.timeExtensionIndicator === 'NULL'" tabindex="0" [attr.aria-expanded]="options">
                            @if (!options) {
                            <i class="fa fa-plus-circle ecorr-opacity-_6"></i>
                            }
                            @if (options) {
                            <i class="fa fa-minus-circle ecorr-opacity-_6"></i>
                            }
                            &nbsp;OPTIONS
                        </button>
                    </div>
                    }
                    <div class="top-padding uscb-flex">
                        @if (survey.timeExtensionIndicator === 'NULL') {
                        <div><span
                                class="config-error-text uscb-layout-column uscb-flex-row"><b>There is a
                                    configuration error for this survey. Please contact the survey help
                                    desk for assistance.</b></span></div>
                        }
                    </div>
                </div>
            </div>

            @if (options) {
            <div class="uscb-flex">
                @if (active) {
                <div class="ops-row uscb-flex uscb-bg-white fx-row-wrap">
                    @if (!showOnlyMessage) {
                    <ng-container>
                        <button class="uscb-transparent-button" (click)="requestExtension()" (keyup.enter)="requestExtension()" 
                        [disabled]="survey.timeExtensionIndicator !== 'Y' || !currentSettings().pegaIntegration" tabindex="0">
                            <i class="fa fa-clock-o"></i>Request Extension
                        </button>
                        <button class="uscb-transparent-button" (click)="shareAccess()" (keyup.enter)="shareAccess()" tabindex="0">
                            <i class="fa fa-users"></i>Share Survey Access
                        </button>
                        <button class="uscb-transparent-button" (click)="checkStatus()" (keyup.enter)="checkStatus()" tabindex="0">
                            <i class="fa fa-check-square-o"></i>Filing Status
                        </button>

                        @if (!showFaqChildren) {
                        <button title="Survey FAQs" class="uscb-transparent-button" (click)="viewFAQs(-1)" (keyup.enter)="viewFAQs(-1)" tabindex="0">
                            <i class="fa fa-question-circle"></i>Survey FAQs
                        </button>
                        }
                        @if (showFaqChildren) {
                        <button title="Rpt. of Org. FAQs" class="uscb-transparent-button" (click)="viewFAQs(0)" (keyup.enter)="viewFAQs(0)" tabindex="0">
                            <i class="fa fa-question-circle"></i>Rpt. of Org. FAQs
                        </button>
                        <button title="ASM FAQs" class="uscb-transparent-button" (click)="viewFAQs(1)" (keyup.enter)="viewFAQs(1)" tabindex="0">
                            <i class="fa fa-question-circle"></i>ASM FAQs
                        </button>
                        }
                    </ng-container>
                    }

                    <button [disabled]="!currentSettings().pegaIntegration" class="uscb-transparent-button" (click)="sendMessage()" (keyup.enter)="sendMessage()" tabindex="0">
                        <i class="fa fa-envelope"></i>Send Message
                    </button>
                    @if (survey.phoneNbr) {
                    <button class="uscb-transparent-button" tabindex="0">
                        <i class="fa fa-phone"></i>
                        Call <b>Survey Support:</b>
                        <div>{{survey.phoneNbr}}</div>
                    </button>
                    }
                </div>
                }
            </div>
            }

            @if (info) {
            <div class="uscb-bg-white">
                <div class="uscb-flex" class="top-padding">{{survey.surveyInformation}}</div>
                @if (survey.infoUrl) {
                <div class="uscb-flex ecorr-padding-TOP-xsm">
                    @if (!survey.infoUrl.includes(';')) {
                    <a class="md-button" (click)="moreInfoClick(-1)" (keyup.enter)="moreInfoClick(-1)" target="_blank" tabindex="0">
                        <b> MORE INFORMATION</b></a>
                    }
                    @if (survey.infoUrl.includes(';')) {
                    <a class="md-button" (click)="moreInfoClick(0)" (keyup.enter)="moreInfoClick(0)" target="_blank" tabindex="0">
                        <b>Rpt. of Org. INFORMATION </b></a>
                    <a class="md-button" (click)="moreInfoClick(1)" (keyup.enter)="moreInfoClick(1)" target="_blank" tabindex="0">
                        <b>ASM INFORMATION </b></a>
                    }
                </div>
                }
            </div>
            }
        </section>
    </div>
</section>
